const styles = theme => ({
  container: {
    display: 'flex',
    paddingTop: '80px',
    paddingBottom: '80px',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
  },
  header: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    /* Heading/H4 Heading */
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  section: {
    color: 'var(--mcg-dark, var(--Info, #5DADFF))',
  },
  title: {
    color: 'var(--mcg-gray, #919EAB)',
    textAlign: 'center',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
})

export default styles
